// extracted by mini-css-extract-plugin
module.exports = {"ticketPage":"tickets_ticketPage__2Mubq","typeOfTicket":"tickets_typeOfTicket__2eCTX","switch":"tickets_switch__15VhW","textWhite":"tickets_textWhite__1Uq1I"};